export const isAvailableLocalStorage = () => {
  try {
    localStorage.setItem('test', 'test_val')
    localStorage.removeItem('test')
    return true
  } catch(error) {
    return false
  }
}

export const isAvailableSessionStorage = () => {
  try {
    sessionStorage.setItem('test', 'test_val')
    sessionStorage.removeItem('test')
    return true
  } catch(error) {
    return false
  }
}
